import Model from "./Model";
import ExamQuestion from "./ExamQuestionModel";

export default class ExamModel extends Model {
  id: number;
  name: string;
  description: string;
  examQuestionsIds: number[];
  examGroupsExamsIds: number[];

  constructor(exam: any, getters: any) {
    super(getters);
    this.id = exam.id;
    this.name = exam.name;
    this.description = exam.description;
    this.examQuestionsIds = exam.examQuestionsByExamId || [];
    this.examGroupsExamsIds = exam.examGroupsExamsByExamId || [];
  }
  questions() {
    return this.examQuestionsIds
      .map((examQuestionId: number) =>
        this.getters.examQuestionById(examQuestionId)
      )
      .sort((a: ExamQuestion, b: ExamQuestion) => b.position - a.position)
      .map((examQuestion: ExamQuestion) => examQuestion.question());
  }
  examGroups() {
    return this.examGroupsExamsIds.map((examGroupsExamId: number) =>
      this.getters.examGroupsExamById(examGroupsExamId).examGroup()
    );
  }
}